<template>
    <div>
        <v-tooltip v-for="(msg, index) in error" :key="`error-${index}`" bottom>
            <template v-slot:activator="{ on }">
                <status-badge class="mb-1" tone="critical" v-on="on">
                    {{ $t('labels.deliverect_error') }}
                </status-badge>
            </template>
            <span>{{ msg }}</span>
        </v-tooltip>

        <v-tooltip
            v-for="(msg, index) in cancel"
            :key="`cancel-${index}`"
            bottom
        >
            <template v-slot:activator="{ on }">
                <status-badge class="mb-1" tone="attention" v-on="on">
                    {{ $t('labels.deliverect_cancel') }}
                </status-badge>
            </template>
            <span>{{ msg }}</span>
        </v-tooltip>
    </div>
</template>

<script>
import StatusBadge from '@/components/elements/StatusBadge.vue'

export default {
    components: {
        StatusBadge,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        error() {
            return this.fieldArr.filter((el) => !el.startsWith('_'))
        },
        cancel() {
            return this.fieldArr
                .filter((el) => el.startsWith('_cancel_'))
                .map((el) => el.replace('_cancel_ ', ''))
        },
        fieldArr() {
            if (!this.item.deliverectError) {
                return []
            }

            return this.item.deliverectError.at(0) === '['
                ? JSON.parse(this.item.deliverectError)
                : [this.item.deliverectError]
        },
    },
}
</script>
